module.exports = __webpack_public_path__ + "a006653a8c3a243e4ff578e674173e4d.png";